import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Card, Badge, Button } from '../components/ui';
import { useApi } from '../lib/hooks';

interface Client {
  id: number;
  name: string;
  label?: string;
  cpc?: number | string;
  status?: string;
  users_count?: number;
}

export default function Clients() {
  const navigate = useNavigate();
  const { data, loading, error } = useApi<Client[]>('/clients/list');

  return (
    <Layout title="Clients" actions={<Button onClick={() => navigate('/clients/new')}>+ Add Client</Button>}>
      {error && <div className="mb-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-4 py-3">{error}</div>}
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wide text-slate-500 bg-surface-muted">
                <th className="px-4 py-3 font-medium">Name</th>
                <th className="px-4 py-3 font-medium">Label</th>
                <th className="px-4 py-3 font-medium">CPC</th>
                <th className="px-4 py-3 font-medium">Users</th>
                <th className="px-4 py-3 font-medium">Status</th>
                <th className="px-4 py-3 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {loading && <tr><td colSpan={6} className="px-4 py-6 text-slate-400">Loading…</td></tr>}
              {data?.map((c) => (
                <tr key={c.id} className="hover:bg-surface-muted/60">
                  <td className="px-4 py-3 font-medium text-ink-900">{c.name}</td>
                  <td className="px-4 py-3 text-slate-500">{c.label || '—'}</td>
                  <td className="px-4 py-3 text-slate-600">{c.cpc != null && c.cpc !== '' ? `$${c.cpc}` : '—'}</td>
                  <td className="px-4 py-3 text-slate-600">{c.users_count ?? 0}</td>
                  <td className="px-4 py-3"><Badge tone={c.status === 'active' ? 'green' : 'neutral'}>{c.status || 'active'}</Badge></td>
                  <td className="px-4 py-3 text-right"><Button variant="outline" onClick={() => navigate(`/clients/edit/${c.id}`)}>Edit</Button></td>
                </tr>
              ))}
              {!loading && (!data || data.length === 0) && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-400">No clients found.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </Layout>
  );
}
